import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClothingRequest } from '../models/clothing.model';

export interface ClothingStorekeeperRequestActionResult {
  action: string;
  description: string;
}

@Component({
  selector: 'app-clothing-storekeeper-request-action-modal',
  templateUrl: './clothing-storekeeper-request-action-modal.component.html',
  styleUrls: ['./clothing-storekeeper-request-action-modal.component.css']
})
export class ClothingStorekeeperRequestActionModalComponent {
  public employeeFullName = '';
  public itemName = '';
  public requestedQuantity = 0;
  public createdAt = '';
  public rejectDescription = '';

  constructor(public activeModal: NgbActiveModal) {}

  setValues(request: ClothingRequest): void {
    this.itemName = request.catalogItemName;
    this.requestedQuantity = request.requestedQuantity;
    this.createdAt = request.createdAt;
  }

  setEmployeeFullName(employeeFullName: string): void {
    this.employeeFullName = employeeFullName || '';
  }

  issue(): void {
    this.activeModal.close(this.createResult('issue'));
  }

  reject(): void {
    this.activeModal.close(this.createResult('reject'));
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  hasEmployeeName(): boolean {
    return !!this.employeeFullName && !!this.employeeFullName.trim().length;
  }

  private createResult(action: string): ClothingStorekeeperRequestActionResult {
    return {
      action: action,
      description: this.resolveRejectDescription()
    };
  }

  private resolveRejectDescription(): string {
    if (!this.rejectDescription) {
      return '';
    }
    return this.rejectDescription.trim();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/clothing-storekeeper-request-action-modal.component.ts